'use client'

import { useTranslate } from '@marketplace-web/shared/i18n'

import { ExamplesSectionModel } from '../../types'
import ExampleSectionCard from './ExampleSectionCard'

type Props = { props: ExamplesSectionModel }

const ExamplesSection = ({ props }: Props) => {
  const { testId, text, cards } = props
  const translate = useTranslate()

  const renderCards = () =>
    cards.map((card, index) => <ExampleSectionCard key={index} props={card} />)

  return (
    <section className="secondhand-taxes__examples-section" data-testid={testId}>
      <h2 className="secondhand-taxes__examples-section-title">{translate(text.title)}</h2>
      <div className="secondhand-taxes__examples-container">{renderCards()}</div>
    </section>
  )
}

export default ExamplesSection
